import { toNumber, isNaN } from 'lodash';

export const formatFloat = (
  value: number | string,
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2
) => {
  const number = toNumber(value);

  if (isNaN(number)) {
    return '-';
  }

  return number.toLocaleString('en-US', { minimumFractionDigits, maximumFractionDigits });
};

export const formatCurrency = (value: number | string) => {
  return `$${formatFloat(value)}`;
};
